import { PageHeader } from '@/components/layout/page-header';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';
import { ScrollTextIcon } from '@/lib/navigation';

type AuditRow = {
  id: string;
  event: string;
  actor: string;
  severity: 'Info' | 'Warning';
  timestamp: string;
};

const auditRows: AuditRow[] = [
  {
    id: 'evt-1042',
    event: 'User role changed to Admin',
    actor: 'ada.lovelace@example.com',
    severity: 'Warning',
    timestamp: '2025-12-08 14:32'
  },
  {
    id: 'evt-1041',
    event: 'User invited',
    actor: 'ada.lovelace@example.com',
    severity: 'Info',
    timestamp: '2025-12-08 11:05'
  },
  {
    id: 'evt-1040',
    event: 'Settings updated',
    actor: 'grace.hopper@example.com',
    severity: 'Info',
    timestamp: '2025-12-07 16:48'
  },
  {
    id: 'evt-1039',
    event: 'Sign-in from new device',
    actor: 'alan.turing@example.com',
    severity: 'Warning',
    timestamp: '2025-12-07 09:12'
  },
  {
    id: 'evt-1038',
    event: 'Item deleted',
    actor: 'grace.hopper@example.com',
    severity: 'Info',
    timestamp: '2025-12-06 18:30'
  }
];

/** Administrative audit log under /admin (placeholder rows until a dedicated API exists). */
export function AdminAuditLogPage() {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Admin audit log"
        description="Administrative events across the workspace (placeholder data)."
        icon={ScrollTextIcon}
      />
      <Card>
        <CardContent className="pt-6">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Event</TableHead>
                <TableHead>Actor</TableHead>
                <TableHead>Severity</TableHead>
                <TableHead className="text-right">Timestamp</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {auditRows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell className="font-medium">{row.event}</TableCell>
                  <TableCell className="text-muted-foreground">{row.actor}</TableCell>
                  <TableCell>
                    <Badge variant={row.severity === 'Warning' ? 'default' : 'outline'}>
                      {row.severity}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-muted-foreground text-right tabular-nums">
                    {row.timestamp}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
